import styled from "styled-components/macro";

export const StyledKeepers = styled.div`
  background: var(--container-color);
  padding: 10px 5px;
  border-radius: 20px;
  width: 100%;
  margin-right: -120px;
  height: 565px;
  position: relative;

  > span {
    float: right;
    font-size: 18px;
    margin-top: -23px;
    margin-right: 6px;
    cursor: pointer;
    color: white;
    font-weight: bold;
    background: var(--primary-cta);
    padding: 2px;
    padding-right: 15px;
    padding-left: 15px;
    border-radius: 15px;
    color: white;
    &:hover {
      opacity: 0.7;
    }
  }

  h3 {
    text-transform: uppercase;
    text-align: center;
    color: var(--grey-1);
    font-size: 16px;
    letter-spacing: 1px;
    margin-top: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 2px;
  }

  .done-btn {
    position: absolute;
    bottom: -70px;
    left: 50%;
    transform: translateX(-50%);
    padding: 12px 24px;
    text-align: center;
    font-size: 18px;
    font-weight: bold;
    color: white;
    border-radius: 30px;
    cursor: pointer;

    background: transparent;
    border: 2px solid var(--primary-cta);
    color: var(--grey-0);

    &:hover {
      background: var(--menu-color-hover);
    }
  }
`;

export const StyledKeepersList = styled.div`
  margin-top: 10px;
  max-height: 520px;
  min-height: 520px;
  padding: 0px 5px;
  overflow-y: auto;

  p {
    font-size: 16px;
    color: #888;
    padding: 6px;
  }
`;

export const StyledThumbsUp = styled.div`
  display: inline-block;
  position: relative;

  svg {
    width: 20px;
    height: 20px;
  }
`;

export const StyledDecoyContainer = styled.div`
  position: relative;
  overflow: visible;

  > div {
    z-index: 999;
  }
`;
